export default {
  permissions: {
    keys: [
      { name: 'name', weight: 1 },
      { name: 'description', weight: 0.5 },
      { name: 'title', weight: 0.5 },
    ],
  },

  accounts: {
    keys: [{ name: 'name', weight: 1 }],
  },

  users: {
    keys: [{ name: 'name', weight: 0.7 }, { name: 'email', weight: 0.3 }],
  },

  vehicles: {
    keys: [{ name: 'registration', weight: 1 }],
  },

  vehicleTypes: {
    keys: [{ name: 'name', weight: 1 }],
  },

  companies: {
    keys: [{ name: 'name', weight: 1 }],
  },

  drivers: {
    keys: [{ name: 'name', weight: 1 }],
  },

  bankingExport: {
    keys: [{ name: 'start', weight: 0.5 }, { name: 'end', weight: 0.5 }],
  },

  holidays: {
    keys: [
      { name: 'name', weight: 1 },
      { name: 'description', weight: 0.5 },
      { name: 'start', weight: 0.75 },
      { name: 'end', weight: 0.75 },
    ],
  },

  accessories: {
    keys: [
      { name: 'name', weight: 1 },
      { name: 'description', weight: 0.5 },
      { name: 'price', weight: 0.25 },
    ],
  },
};
